/** @format */

import { FormattedMessage } from 'gatsby-plugin-intl';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import { VRButton, VrIcon } from './RoomGallery.style';

type picturesForGallery = (
  | {
      index: number;
      url: string;
      type: string;
      poster: any;
      alt?: undefined;
      thumbnail?: undefined;
      representative?: undefined;
    }
  | {
      index: number;
      url: string;
      alt: string;
      thumbnail: string;
      representative: boolean;
      type?: undefined;
      poster?: undefined;
    }
  | undefined
)[];

interface MobileGalleryPreviewProps {
  picturesForGallery: picturesForGallery;
  hasVR: boolean;
  handleClickVrIcon: () => void;
  setShowInsideGallery: (show: boolean) => void;
  handleGTMPDPRoomGalleryImageAndAllClick: () => void;
}

const MobileGalleryPreview: React.FC<MobileGalleryPreviewProps> = ({
  picturesForGallery,
  hasVR,
  handleClickVrIcon,
  setShowInsideGallery,
  handleGTMPDPRoomGalleryImageAndAllClick,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <SwiperGallery
      onClick={() => picturesForGallery.length > 1 && setShowInsideGallery(true)}
      slidesPerView={1}
      lazy={{
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      }}
      onSlideChange={e => setCurrentIndex(e.realIndex)}
    >
      {picturesForGallery &&
        picturesForGallery.map((photo, index) =>
          photo && photo.url ? (
            <SwiperSlide
              key={index}
              onClick={() => {
                setShowInsideGallery(true);
                handleGTMPDPRoomGalleryImageAndAllClick();
              }}
            >
              <SwiperImageContainer $rappresentative={photo && photo.representative ? true : false}>
                <img
                  key={index}
                  src={photo.representative ? photo.url : photo.thumbnail}
                  alt={photo.alt}
                  data-src={photo.representative ? photo.url : photo.thumbnail}
                />
                {photo.representative && (
                  <span>
                    <FormattedMessage id="pdp.representative_image" />
                  </span>
                )}
              </SwiperImageContainer>
            </SwiperSlide>
          ) : null,
        )}
      <SwiperCounter>
        <div
          style={{
            width: '25px',
          }}
        />
        {hasVR && (
          <VRButton onClick={handleClickVrIcon} type="button">
            <img src={VrIcon} alt="Vr icon" />
            <div className="virtual-tour-content">Virtual tour</div>
          </VRButton>
        )}
        <div>
          {currentIndex + 1} / {picturesForGallery.length}
        </div>
      </SwiperCounter>
    </SwiperGallery>
  );
};

export default MobileGalleryPreview;

const SwiperImageContainer = styled.div<{ $rappresentative?: boolean }>`
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    filter: ${({ $rappresentative }) => $rappresentative && 'blur(7px)'};
  }
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    font-family: ${({ theme }) => theme.font.title};
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.joivy.white};
    text-shadow: rgba(0, 0, 0, 0.4) 0px 1px 1px;
  }
`;

const SwiperCounter = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 2;
  right: 0;
  padding: 10px 15px;
  color: ${({ theme }) => theme.colors.joivy.white};
  text-align: center;
  font-family: ${({ theme }) => theme.font.body};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  text-align: right;
  width: 100%;
  background: linear-gradient(to bottom, transparent, ${({ theme }) => theme.colors.joivy.black});
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SwiperGallery = styled(Swiper)`
  position: relative;
  left: -10px;
  height: 100%;
  width: calc(100% + 20px);
  display: none;
  .swiper-slide {
    width: 100% !important;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xs}) {
    display: block;
  }
`;
